import React from 'react';
import './Loader.css';

function Loader() {
  return (
    <div className="code-loader">
      <span>{"{...}"}</span>
    </div>
  );
}

export default Loader;
